export default __webpack_public_path__ + "static/Gmail2-55bc16e7549fbd56dbb50ab123d2bddb.png";